document.addEventListener('DOMContentLoaded', () => {
    
    // ==================== FAQ ACCORDION LOGIC ====================
    const faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach(item => {
        const questionGroup = item.querySelector('.faq-question-group');
        questionGroup.addEventListener('click', () => {
            const isOpen = item.classList.contains('open');
            
            // Close all items
            faqItems.forEach(faq => faq.classList.remove('open'));
            
            // Open clicked item if it was closed
            if (!isOpen) {
                item.classList.add('open');
            }
        });
    });

    // ==================== CHECKOUT DIRECT LINK (REAL CHECKOUT) ====================
    const openButtons = document.querySelectorAll('.open-checkout-btn');
    
    // Redirect direct to Shopify Checkout with Variant ID
    openButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            window.location.href = 'https://miapresto.cl/cart/49016878629115:1';
        });
    });

    // ==================== NAVIGATION ACTIVE LINK SCROLLING ====================
    const sections = document.querySelectorAll('section');
    const navLinks = document.querySelectorAll('.nav-link');

    window.addEventListener('scroll', () => {
        let current = '';
        sections.forEach(section => {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.clientHeight;
            if (window.scrollY >= (sectionTop - 160)) {
                current = section.getAttribute('id');
            }
        });

        navLinks.forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('href').slice(1) === current) {
                link.classList.add('active');
            }
        });
    });

    // ==================== COUNTDOWN TIMER LOGIC ====================
    let timeLeft = 15 * 60; // 15 minutes in seconds
    const heroTimer = document.getElementById('hero-countdown');
    const productTimer = document.getElementById('product-countdown');
    const headerTimer = document.getElementById('header-countdown');

    function updateTimer() {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        
        if (heroTimer) heroTimer.textContent = formattedTime;
        if (productTimer) productTimer.textContent = formattedTime;
        if (headerTimer) headerTimer.textContent = formattedTime;
        
        if (timeLeft <= 0) {
            timeLeft = 15 * 60; // loops/resets for demonstration
        } else {
            timeLeft--;
        }
    }
    
    setInterval(updateTimer, 1000);
    updateTimer();
});
